import {
  arrayResolver,
  objectResolver,
  optionalResolver,
  resolveBoolean,
  resolveNumber,
  resolveString,
} from 'airship/utils/resolvers'
import type {Resolver} from 'airship/utils/resolvers/types'

export type UserProfile = {
  first_name: string
  last_name: string
  username: string
  email: string
  industry?: string
  role?: string
  country?: string
  meta: UserProfileMeta
}

export type UserProfileMeta = {
  is_oidc_authenticated: boolean
  is_oidc_required: boolean
  has_usable_password: boolean
  is_sso_user: boolean
}

export const resolveUserProfile: Resolver<UserProfile> = objectResolver({
  first_name: resolveString,
  last_name: resolveString,
  username: resolveString,
  email: resolveString,
  industry: optionalResolver(resolveString),
  role: optionalResolver(resolveString),
  country: optionalResolver(resolveString),
  meta: objectResolver({
    is_oidc_authenticated: resolveBoolean,
    is_oidc_required: resolveBoolean,
    has_usable_password: resolveBoolean,
    is_sso_user: resolveBoolean,
  }),
})

export const resolvePartialUserProfile: Resolver<Partial<UserProfile>> =
  objectResolver({
    first_name: optionalResolver(resolveString),
    last_name: optionalResolver(resolveString),
    username: optionalResolver(resolveString),
    email: optionalResolver(resolveString),
  })

export type ReviewUser = {
  id: number
  email: string
}
export type ReviewUserList = {
  objects: ReviewUser[]
}

export const resolveReviewUser: Resolver<ReviewUser> = objectResolver({
  id: resolveNumber,
  email: resolveString,
})

export const resolveReviewUsers: Resolver<ReviewUserList> = objectResolver({
  objects: arrayResolver(resolveReviewUser),
})
